import { useTranslation } from "@/hooks/useTranslation";
import { useMemo } from "react";
import { ErrorRule, isErrorRuleDetails } from "@/types/error";

export function getErrorMessage({
  field,
  error,
  t,
  additionalData,
}: {
  field: string,
  error: ErrorRule,
  t: ReturnType<typeof useTranslation>['t'],
  additionalData?: Record<string, string | number>,
}) {
  const isDetails = isErrorRuleDetails(error);
  const failedKey = isDetails ? Object.keys(error)[0] : error[0];

  const config = isDetails ? { [failedKey]: error[failedKey]?.[0] } : undefined;

  return t(`validation.${failedKey}`, { field, ...config, ...additionalData });
}

export const FormErrorDisplay = ({ field, error }: { field: string, error?: ErrorRule }) => {
  const { t } = useTranslation('errors');

  const errorMessage = useMemo(() => {
    if (!error) {
      return null;
    }

    return getErrorMessage({ field, error, t });
  }, [error, field, t]);

  if (!error) {
    return null;
  }

  return <div className="text-red-500">{errorMessage}</div>;
};
